import type { DataTableColumn } from '@/components/ui/data-table-customized'
import { createOptionsFormatter } from '@/components/ui/data-table-customized'
import { Permission } from '../../../types'

export const getPermissionColumns = (): DataTableColumn<Permission>[] => [
    {
        key: 'name',
        title: 'Name',
        width: 400,
    },
    {
        key: 'displayName',
        title: 'Display Name',
        width: 200,
        valueGetter: (row) => row.displayName || '-',
    },
    {
        key: 'type',
        title: 'Type',
        width: 150,
        formatter: createOptionsFormatter({
            options: [
                { label: 'Resource', value: 'resource', color: 'primary' },
                { label: 'Scope', value: 'scope', color: 'info' },
            ],
            renderMode: 'chip',
        }),
    },
    {
        key: 'decisionStrategy',
        title: 'Decision Strategy',
        width: 150,
        valueGetter: (row) => row.decisionStrategy || '-',
    },
    {
        key: 'logic',
        title: 'Logic',
        width: 120,
        formatter: createOptionsFormatter({
            options: [
                { label: 'Positive', value: 'POSITIVE', color: 'success' },
                { label: 'Negative', value: 'NEGATIVE', color: 'warning' },
            ],
            renderMode: 'chip',
        }),
    },
]
